<div nz-row nzJustify="space-around" nzAlign="middle" style="width: 100vw; height: 100vh; overflow: hidden;">
    <div>
        <nz-spin nz-col nzSimple></nz-spin>
    </div>
</div>